import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {RestPersonService} from '@app/core/api/person.service';
import {ActivePersonQuery} from '@app/core/state/active-person/active-person.query';
import {ActivePersonStore} from '@app/core/state/active-person/active-person.store';
import {CompareUtil} from '@app/core/util/compare.util';
import {PayloadUtil} from '@app/core/util/payload.util';
import {PayloadPerson, PayloadPersonPraemien, Person, PersonPraemien} from '@pezi/entities';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {take} from 'rxjs/operators';
import {setProps} from "@ngneat/elf";

@Injectable({providedIn: 'root'})
export class ActivePersonService {

  private subscription: Subscription;

  constructor(private activePersonStore: ActivePersonStore,
              private activePersonQuery: ActivePersonQuery,
              private personService: RestPersonService,
              private snackBar: MatSnackBar) {
  }

  initPerson(personId: number, version?: number) {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.activePersonStore.data.update(setProps({
        loading: false
      }));
    }
    const currentState = this.activePersonStore.data.getValue();
    if (!personId) {
      this.clearStore();
    } else {
      if (!currentState.person || +currentState.person.id !== +personId || !CompareUtil.hasSameVersion(version, currentState.person)) {

        const personObservable = (!version || version === 1) ? this.personService.getPersonForId(personId) : this.personService.getPersonVersionForId(personId, version);
        const praemieObservable = this.personService.getPraemienForPerson(+personId);
        this.activePersonStore.data.reset();
        this.activePersonStore.data.update(setProps({
          loading: true
        }));
        this.subscription = this.initPersonPraemieSub(personObservable, praemieObservable)
      }
    }
  }

  clearStore() {
    this.activePersonStore.data.reset();
  }

  private initPersonPraemieSub(personObservable: Observable<PayloadPerson>, praemieObservable: Observable<PayloadPersonPraemien>): Subscription {
    return forkJoin({
      person: personObservable,
      praemie: praemieObservable
    })
      .pipe(
        take(1)
      )
      .subscribe(result => {
        let person: Person;
        let praemie: PersonPraemien;
        let errorLoadingPerson = false;
        if (PayloadUtil.handlePayloadSnackbarErrorOnly(result.person, this.snackBar,
          'Fehler: Person konnte nicht geladen werden')) {
          person = result.person.data;
        } else {
          errorLoadingPerson = true;
        }
        if (!result.praemie) {
          praemie = this.activePersonStore.data.getValue().praemie;
        } else if (PayloadUtil.handlePayloadSnackbarErrorOnly(result.praemie, this.snackBar,
          'Fehler: Prämie zur Person konnte nicht geladen werden')) {
          praemie = result.praemie.data;
        }
        this.activePersonStore.data.update(setProps({
          loading: false,
          errorLoading: errorLoadingPerson,
          person,
          praemie
        }));
      });
  }
}
